import React from 'react'
import "./layout.css"
import Header from "./Header"
import Footer from "./Footer"

export default ({ children }) => <><Header /><div className="container">{children}</div><Footer /></>